const routes = [
    {
        path: "/daily/attendance/entry",
        component: () => import("../pages/Entry"),
        meta: {
            isAuthenticated: true,
            permission: "prepattendance_index"
        },
        component_full_path: 'dailyAttendanceEntry/pages/Entry'
    }
];

export default routes;
